module.exports = __webpack_public_path__ + "static/media/999_grey.caaf327b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/assets/999_grey.svg
// module id = 591
// module chunks = 20